export default "__VITE_ASSET__D1nj7Qb0__"